<template lang="pug">
.insights-empty.d-flex.flex-column.justify-content-center.align-items-center
  .insights-empty-panel.text-center
    img.no-activity(:src="IMAGE_NO_ACTIVITY")
    p.mt-20
      | There isn't any time tracked during this period. To track time&nbsp;
      a(
        href="https://app.hubstaff.com/download"
        rel="noopener noreferrer"
        target="_blank"
      ) use one of our apps
      | .
</template>

<script>
import { IMAGE_NO_ACTIVITY } from '~/rails_assets';

export default {
  name: 'InsightsEmpty',
  data: () => ({
    IMAGE_NO_ACTIVITY,
  }),
};
</script>
